<template>
    <div>
        <div class="columns is-multiline">
            <div class="column is-12">
                <applications-under-review :year="underReviewYear"/>
            </div>
        </div>
        <div class="columns is-multiline">
            <div class="column is-12">
                <applications-signed-off :year="signedOffYear"/>
            </div>
        </div>
    </div>
</template>

<script>
    import ApplicationsSignedOff from './applications/SignedOff'
    import ApplicationsUnderReview from './applications/UnderReview'

    export default {
        components: {
            ApplicationsUnderReview,
            ApplicationsSignedOff
        },

        data () {
            return {
                underReviewYear: 2017,
                signedOffYear: 2017
            }
        }
    }
</script>
